var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bolt_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bolt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.488.581a1.5 1.5 0 0 1 1.003 1.585L25.676 18.5H38a1.5 1.5 0 0 1 1.278 2.286l-16 26a1.5 1.5 0 0 1-2.769-.952L22.324 29.5H10a1.5 1.5 0 0 1-1.277-2.286l16-26A1.5 1.5 0 0 1 26.488.58ZM12.684 26.5H24a1.5 1.5 0 0 1 1.49 1.666l-1.26 11.348L35.316 21.5H24a1.5 1.5 0 0 1-1.49-1.666l1.26-11.348L12.684 26.5Z",
    fill: "#004152"
  }))));
};
export default SvgBolt;